import React from 'react';
import cn from 'classnames';
import { prefix, splitBsPropsAndOmit, bsClass } from './utils/bootstrapUtils';
import PanelCollapse from './PanelCollapse';
import { PanelContext } from '../Panel/PanelContext';
import { jsx as _jsx } from "react/jsx-runtime";
class PanelBody extends React.Component {
  render() {
    const {
      children,
      className,
      collapsible = false
    } = this.props;
    const {
      bsClass: _bsClass
    } = this.context || {};
    const [bsProps, elementProps] = splitBsPropsAndOmit(this.props, ['collapsible']);
    bsProps.bsClass = _bsClass || bsProps.bsClass;
    let body = /*#__PURE__*/_jsx("div", {
      ...elementProps,
      className: cn(className, prefix(bsProps, 'body')),
      children: children
    });
    if (collapsible) {
      body = /*#__PURE__*/_jsx(PanelCollapse, {
        children: body
      });
    }
    return body;
  }
}
PanelBody.contextType = PanelContext;
export default bsClass('panel', PanelBody);